<template>
  <layout-panel>
    <template slot="header">
      模板信息
    </template>

    <el-form
      :rules="infoRules"
      ref="form"
      :model="form"
      @submit.native.prevent>
      <el-form-item prop="title">
        <el-input v-model="form.title"
                  placeholder="请输入模板标题">
        </el-input>
      </el-form-item>
      <el-form-item prop="detail">
        <el-input v-model="form.detail"
                  placeholder="请输入模板描述"
                  type="textarea"
                  :autosize="{ minRows: 3}">
          <template slot="prepend">描述</template>
        </el-input>
      </el-form-item>

      <el-form-item>
        <template>
          <el-tooltip class="item" effect="dark" content="开启后用户执行任务时将全程录音且该模板不可添加其他录音视频类题目。" placement="bottom">
            <span>全程录音<i class="el-icon-question" style="color: #E6A23C" /></span>
          </el-tooltip>
          <el-switch
            v-model="form.through_record">
          </el-switch>
        </template>
        <span style="display: inline-block;width: 30px;"></span>
        <template v-if="form.through_record">
          <el-tooltip class="item" effect="dark" content="开启后零工可在执行任务过程中，手动标记录音" placement="bottom">
            <span>零工重点录音标记<i class="el-icon-question" style="color: #E6A23C" /></span>
          </el-tooltip>
          <el-switch
            v-model="form.through_record_flag">
          </el-switch>
        </template>
      </el-form-item>
      <el-form-item>
      <el-tooltip class="item" effect="dark" content="开启后用户第一次（排除门头题）完成需要拍摄照片的题目进入下一步时，静默调用前置摄像头拍摄1张照片，并静默上传" placement="bottom">
          <span>执行中前置镜头抓拍<i class="el-icon-question" style="color: #E6A23C" /></span>
        </el-tooltip>
        <el-switch
          v-model="form.has_sneak_photos">
        </el-switch>
      </el-form-item>
      <el-form-item style="margin-bottom: 12px;">
        强制用户结束答题的题号：
        <el-input-number
          v-model.number="form.extended_steps_start"
          controls-position="right"
          size="mini"
          :min="0"/>

      </el-form-item>
      <span class="end-answer-explain">
        1. 使用时有app版本要求
         </span>
      <span class="end-answer-explain">
        2. 显示题和隐藏题之间不能有逻辑跳转
          </span>
        <span class="end-answer-explain">
        3. 0 表示不强制
            </span>
          <span class="end-answer-explain">
        4. 不能和结束答题共用
       </span>
      <template v-if="scope === 'clb'">
        <el-form-item style="margin-bottom: 12px;">
          积分：
          <el-input-number v-model="form.points"
                           :precision="0"
                           :min="0"
                           :controls="false"
                           size="small"/>
          豆
          <span style="padding-left: 20px;"/>
          赏金：
          <el-input-number v-model="form.salary"
                           :precision="2"
                           :min="0"
                           :controls="false"
                           size="small"/>
          元
        </el-form-item>
        查理宝占位符: 一级区域 <code>{$AREANAME}</code> 二级分类 <code>{$CATEGORYNAME}</code> 产品名称 <code>{$PRODUCTNAME}</code>
      </template>
    </el-form>
  </layout-panel>
</template>

<script>
import { infoRules } from '../step-template.rules.js'

export default {
  components: {},
  inject: ['scope'],
  props: {
    value: Object,
    disabled: Boolean,
  },
  data () {
    return {
      infoRules,
    }
  },
  computed: {
    form: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {},
  created () {},
  mounted () {},
  methods: {
    ...request.map([
      'getProjectDetail',
    ]),
    validate (callback) {
      this.$refs.form.validate(callback)
    },
  },
  filters: {},
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
.end-answer-explain {
  display: block;
  font-size: 10px;
  margin-left: 10px;
  color: #909399;
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/step-template/components/StepTemplateInfo.vue